import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 메일 보내기
export const sendEmail = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/consultings/emails/marketing`, params)
      .then((res) => {
        toast.success("이메일 전송에 성공했습니다.")
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
